var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('iframe',{attrs:{"id":"blockrandom","name":"iframe","src":"/professionnalisation2","width":"100%","height":"12000","loading":"lazy","title":"Le programme de professionnalisation"}},[_vm._v(" Cette option ne fonctionnera pas correctement. Malheureusement, votre navigateur ne supporte pas les frames. ")])])
}]

export { render, staticRenderFns }